import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import { isEmptyDocument } from '@atlaskit/editor-common/utils';

import type { AIPlugin } from '../../aiPluginType';
import type { EditorPluginAIProvider } from '../../types/types';
import { aiExperienceDecorationPluginKey } from '../decoration/decoration-plugin-key';

export const createPlaceholderControllerPlugin = (options: {
	api: ExtractInjectionAPI<AIPlugin> | undefined;
	editorPluginAIProvider: EditorPluginAIProvider;
}): SafePlugin => {
	const { api } = options;

	return new SafePlugin({
		view() {
			let previousIsRunning = false;
			return {
				update(view) {
					if (!api?.placeholder || !api?.core) {
						return;
					}

					const state = view.state;
					const aiDecorationState = aiExperienceDecorationPluginKey.getState(state);
					const currentIsRunning = aiDecorationState?.isRunning ?? false;

					if (currentIsRunning !== previousIsRunning) {
						previousIsRunning = currentIsRunning;

						if (options.editorPluginAIProvider.isInDocumentStreamingEnabled) {
							api.core.actions.execute(
								api.placeholder.commands.setPlaceholderHidden(currentIsRunning),
							);
						} else {
							if (isEmptyDocument(state.doc)) {
								api.core.actions.execute(
									api.placeholder.commands.setPlaceholderHidden(currentIsRunning),
								);
							}
						}
					}
				},
			};
		},
	});
};
